export default __webpack_public_path__ + "static/media/README.071cb872.md";